import React from 'react';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import type { OrderStockLine } from '../../api/orderStockStatusApi';
import type { OrderProduct } from '../../../../types/order';
import { OrderLineNameWithDimensions, useQuantityFormatter } from '../OrderProcessTables';

/**
 * „Stan magazynu” of the confirmation window (Produkt / Zamówiono / Na
 * magazynie / Do zamówienia): shown inline and, with „Zobacz stan magazynu”,
 * in its own window. The on-hand column is hidden when the reader gets no
 * stock level (Handlowiec). Dimensions come from the order line (`products`).
 */
export default function ConfirmStockTable({ lines, testId, products = [] }: { lines: OrderStockLine[]; testId: string; products?: OrderProduct[] }) {
  const { t } = useTranslation(['orders']);
  const quantity = useQuantityFormatter();
  const productsById = new Map(products.map((product) => [product.id, product]));
  const showOnHand = lines.some((line) => line.onHand !== null);
  return (
    <div className="zk-confirm__table-wrap">
      <table className="zk-confirm__table" data-testid={testId}>
        <thead>
          <tr>
            <th>{t('orders:process.confirmDialog.columns.product')}</th>
            <th className="r">{t('orders:process.confirmDialog.columns.ordered')}</th>
            {showOnHand && <th className="r">{t('orders:process.confirmDialog.columns.onHand')}</th>}
            <th className="r">{t('orders:process.confirmDialog.columns.toOrder')}</th>
          </tr>
        </thead>
        <tbody>
          {lines.map((line) => (
            <tr key={line.orderProductId}>
              <td><OrderLineNameWithDimensions name={<b>{line.name}</b>} product={productsById.get(line.orderProductId)} testId={`${testId}-line-dimensions`} /></td>
              <td className="r zk-num">{quantity(line.ordered, line.unit)}</td>
              {showOnHand && (
                <td className="r zk-num">{line.onHand == null ? '—' : quantity(Math.min(line.onHand, line.ordered ?? line.onHand), line.unit)}</td>
              )}
              <td className="r">
                {line.state === 'MISSING' && (line.missing ?? 0) > 0
                  ? <Tag color="orange">{quantity(line.missing, line.unit)}</Tag>
                  : line.state === 'UNKNOWN'
                    ? <Tag>{t('orders:confirmationNotice.unknown')}</Tag>
                    : <Tag color="green">0</Tag>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
